import type { Booking } from '@brighterly/lib-core-types/booking/interfaces'
import type { Voip } from '@brighterly/lib-core-types/support/enums'

import { useDisciplineStore } from '@entities/customer'
import { useKidStore } from '@entities/customer'
import { useActiveKidDisciplinesApi } from '@entities/customer'
import { useKidInCustomer } from '@entities/customer'

export const useMiddlewareBookingVoip = async (booking: Booking | null): Promise<Voip | null> => {
  const disciplineStore = useDisciplineStore()
  const kidStore = useKidStore()

  const activeVoip = disciplineStore.activeDiscipline?.voip

  if (activeVoip) {
    return activeVoip
  }

  const { kid } = useKidInCustomer({ kidId: kidStore.activeKidId })
  const customerVoip = kid.value?.disciplines.find(discipline => discipline.code === booking?.discipline)?.voip

  if (customerVoip) {
    return customerVoip
  }

  if (kidStore.activeKidId === null) return null

  const disciplines = await useActiveKidDisciplinesApi(kidStore.activeKidId)
  const disciplineInfo = disciplines?.find(discipline => discipline.code === booking?.discipline)
    ?? disciplines?.find(discipline => discipline.id === disciplineStore.activeDiscipline?.id)

  return disciplineInfo?.kid.voip ?? null
}
